export default __webpack_public_path__ + "static/media/productphoto.2e0c0202.png";